import React, { useContext, useEffect, useState } from "react";
import { ControlpanelContext } from "../../../util/context";
import FeatureSelection from "../../components/FeatureSelection";
import LabeledInputToggle from "../../components/LabeledInputToggle";
import "./FeatureSetup.scss";

export default function FeatureSetup() {

  const { payloadFeatures, setPayloadFeatures,
    isFeatureEnabled, setIsFeatureEnabled,
    payloadFeaturesError, setPayloadFeaturesError
  } = useContext(ControlpanelContext)

  const dashboardOptions = [
    { label: "All", value: "All", isDisable: false },
    { label: "Members Dashboard", value: "Members Dashboard", isDisable: true },
    { label: "Organization Dashboard", value: "Organization Dashboard", isDisable: false },
  ];

  const timesheetOptions = [
    { label: "All", value: "All", isDisable: false },
    { label: "Automatic Project Tagging", value: "Automatic Project Tagging", isDisable: false },
    { label: "In-App Chatbot Support", value: "In-App Chatbot Support", isDisable: true },
    { label: "Sundial", value: "Sundial Time Sheet", isDisable: true },
  ];

  const ReportOptions = [
    { label: "All", value: "All", isDisable: false },
    { label: "View", value: "View", isDisable: true },
    { label: "Export", value: "Export", isDisable: false },
  ];

  const IntegrationOptions = [
    { label: "All", value: "All", isDisable: false },
    { label: "Biotime", value: "BioTime", isDisable: false }
    // { label: "Outlook", value: "Outlook" },
    // { label: "Teams", value: "Teams" },
    // { label: "Calendar", value: "Calendar" },
  ];

  const OthersOptions = [
    { label: "All", value: "All", isDisable: false },
    { label: "Team lead", value: "Team lead", isDisable: false },
    { label: "Multi Language Support", value: "Multi Language Support", isDisable: true },
  ];

  const handleToggle = (e, code) => {
    setIsFeatureEnabled({
      ...isFeatureEnabled,
      [code]: e.target.checked
    })
    if (!e.target.checked) {
      let newObject = Object.fromEntries(
        Object.entries(payloadFeatures).filter(([key]) => key !== code)
      );
      setPayloadFeatures({
        ...newObject
      })
      setPayloadFeaturesError({
        ...payloadFeaturesError,
        [code]: ""
      })
    }
  };

  return (
    <div className="FeatureContents">

      <FeatureSelection title="Dashboard"
        code={"DASHBOARD"}
        setPayloadFeatures={setPayloadFeatures}
        setIsFeatureEnabled={setIsFeatureEnabled}
        payloadFeatures={payloadFeatures}
        isFeatureEnabled={isFeatureEnabled}
        options={dashboardOptions} />

      <FeatureSelection title="AI Features"
        code={"TIMESHEET"}
        setPayloadFeatures={setPayloadFeatures}
        setIsFeatureEnabled={setIsFeatureEnabled}
        payloadFeatures={payloadFeatures}
        isFeatureEnabled={isFeatureEnabled}
        options={timesheetOptions} />

      <FeatureSelection title="Report"
        code={"REPORT"}
        setPayloadFeatures={setPayloadFeatures}
        setIsFeatureEnabled={setIsFeatureEnabled}
        payloadFeatures={payloadFeatures}
        isFeatureEnabled={isFeatureEnabled}
        options={ReportOptions} />

      <FeatureSelection title="Integration"
        code={"INTEGRATION"}
        setPayloadFeatures={setPayloadFeatures}
        setIsFeatureEnabled={setIsFeatureEnabled}
        payloadFeatures={payloadFeatures}
        isFeatureEnabled={isFeatureEnabled}
        options={IntegrationOptions} />

      <FeatureSelection title="Others"
        code={"OTHERS"}
        setPayloadFeatures={setPayloadFeatures}
        setIsFeatureEnabled={setIsFeatureEnabled}
        payloadFeatures={payloadFeatures}
        isFeatureEnabled={isFeatureEnabled}
        options={OthersOptions} />

      <LabeledInputToggle
        code={"PROJECT_COUNT"}
        label="Project count"
        placeholder="Enter value"
        value={payloadFeatures["PROJECT_COUNT"] !== undefined ? payloadFeatures["PROJECT_COUNT"][0] : ""}
        onChange={(e) => {
          if (!/^\d*$/.test(e.target.value)) return;
          if ((e.target.value).length > 5) return;
          setPayloadFeaturesError({ ...payloadFeaturesError, PROJECT_COUNT: "" })
          setPayloadFeatures({
            ...payloadFeatures,
            PROJECT_COUNT: e.target.value !== "" ? [e.target.value] : []
          })
        }}
        onPaste={(e) => {
          const pasteData = e.clipboardData.getData("text");
          if (!/^\d*$/.test(pasteData) || pasteData.length > 5) {
            e.preventDefault();
          }
        }}
        checked={isFeatureEnabled["PROJECT_COUNT"]}
        onToggle={(e) => handleToggle(e, "PROJECT_COUNT")}
        error={payloadFeaturesError.PROJECT_COUNT}
      />
      <LabeledInputToggle
        code={"MEMBER_COUNT"}
        required={true}
        label="Member count"
        placeholder="Enter value"
        value={payloadFeatures["MEMBER_COUNT"] !== undefined ? payloadFeatures["MEMBER_COUNT"][0] : ""}
        onChange={(e) => {
          if (!/^\d*$/.test(e.target.value)) return;
          if ((e.target.value).length > 5) return;
          setPayloadFeaturesError({ ...payloadFeaturesError, MEMBER_COUNT: "" })
          setPayloadFeatures({
            ...payloadFeatures,
            MEMBER_COUNT: e.target.value !== "" ? [e.target.value] : []
          })
        }}
        onPaste={(e) => {
          const pasteData = e.clipboardData.getData("text");
          if (!/^\d*$/.test(pasteData) || pasteData.length > 5) {
            e.preventDefault();
          }
        }}
        checked={true}
        onToggle={(e) => handleToggle(e, "MEMBER_COUNT")}
        error={payloadFeaturesError.MEMBER_COUNT}
      />
      <LabeledInputToggle
        code={"TAG_COUNT"}
        label="Tags count"
        placeholder="Enter value"
        value={payloadFeatures["TAG_COUNT"] !== undefined ? payloadFeatures["TAG_COUNT"][0] : ""}
        onChange={(e) => {
          if (!/^\d*$/.test(e.target.value)) return;
          if ((e.target.value).length > 5) return;
          setPayloadFeaturesError({ ...payloadFeaturesError, TAG_COUNT: "" })
          setPayloadFeatures({
            ...payloadFeatures,
            TAG_COUNT: e.target.value !== "" ? [e.target.value] : []
          })
        }}
        onPaste={(e) => {
          const pasteData = e.clipboardData.getData("text");
          if (!/^\d*$/.test(pasteData) || pasteData.length > 5) {
            e.preventDefault();
          }
        }}
        checked={isFeatureEnabled["TAG_COUNT"]}
        onToggle={(e) => handleToggle(e, "TAG_COUNT")}
        error={payloadFeaturesError.TAG_COUNT}
      />
      <LabeledInputToggle
        code={"DAILY_AI_SUMMARIZATION_LIMITS"}
        label="Daily AI summarizations"
        placeholder="Enter value"
        value={payloadFeatures["DAILY_AI_SUMMARIZATION_LIMITS"] !== undefined ? payloadFeatures["DAILY_AI_SUMMARIZATION_LIMITS"][0] : ""}
        onChange={(e) => {
          if (!/^\d*$/.test(e.target.value)) return;
          if ((e.target.value).length > 5) return;
          setPayloadFeaturesError({ ...payloadFeaturesError, DAILY_AI_SUMMARIZATION_LIMITS: "" })
          setPayloadFeatures({
            ...payloadFeatures,
            DAILY_AI_SUMMARIZATION_LIMITS: e.target.value !== "" ? [e.target.value] : []
          })
        }}
        onPaste={(e) => {
          const pasteData = e.clipboardData.getData("text");
          if (!/^\d*$/.test(pasteData) || pasteData.length > 5) {
            e.preventDefault();
          }
        }}
        checked={isFeatureEnabled["DAILY_AI_SUMMARIZATION_LIMITS"]}
        onToggle={(e) => handleToggle(e, "DAILY_AI_SUMMARIZATION_LIMITS")}
        showPerUser={true}
        error={payloadFeaturesError.DAILY_AI_SUMMARIZATION_LIMITS}
      />
    </div>

  );
}
